.gas-public-members {
    max-width: 1180px;
    margin: 0 auto;
    padding: clamp(24px, 4vw, 48px) 16px;
    color: var(--gas-color-text);
}

.gas-public-members__hero,
.gas-public-members__filters,
.gas-public-members__summary,
.gas-public-members__toolbar,
.gas-public-members__pagination {
    border: 1px solid var(--gas-color-border);
    border-radius: var(--gas-radius-xl);
    background: var(--gas-color-surface);
    box-shadow: var(--gas-shadow-sm);
}

.gas-public-members__hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    padding: clamp(20px, 3vw, 32px);
    margin-bottom: 16px;
}

.gas-public-members__hero h1 {
    margin: 4px 0 8px;
    font-size: clamp(32px, 4vw, 51.2px);
    line-height: 1.05;
}

.gas-public-members__hero p {
    margin: 0;
    color: var(--gas-color-muted);
}

.gas-public-members__eyebrow {
    text-transform: uppercase;
    letter-spacing: .12em;
    font-size: 12.48px;
    font-weight: 700;
    color: var(--gas-color-primary);
}

.gas-public-members__map-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: 10.4px 16px;
    border-radius: 999px;
    color: var(--gas-color-primary);
    background: var(--gas-color-primary-soft);
    text-decoration: none;
    font-weight: 700;
    white-space: nowrap;
}

.gas-public-members__filters {
    padding: 16px;
    margin-bottom: 16px;
}

.gas-public-members__search {
    position: relative;
    margin-bottom: 16px;
}

.gas-public-members label,
.gas-public-members__cantons-head {
    display: grid;
    gap: 6.4px;
    font-weight: 700;
}

.gas-public-members input[type="search"],
.gas-public-members select {
    width: 100%;
    min-height: 44px;
    border: 1px solid var(--gas-color-border);
    border-radius: var(--gas-radius-md);
    padding: 10.4px 12.8px;
    background: var(--gas-color-surface);
    color: inherit;
}

.gas-public-members__suggestions {
    position: absolute;
    z-index: 20;
    inset-inline: 0;
    top: calc(100% + 5.6px);
    border: 1px solid var(--gas-color-border);
    border-radius: var(--gas-radius-lg);
    background: var(--gas-color-surface);
    box-shadow: var(--gas-shadow-lg);
    overflow: hidden;
}

.gas-public-members__suggestion {
    display: block;
    width: 100%;
    border: 0;
    padding: 12px 14.4px;
    background: transparent;
    text-align: left;
    color: inherit;
    cursor: pointer;
}

.gas-public-members__suggestion:hover,
.gas-public-members__suggestion:focus {
    background: var(--gas-color-muted-soft);
}

.gas-public-members__filter-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 13.6px;
}

.gas-public-members__cantons {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--gas-color-border);
}

.gas-public-members__cantons-head {
    grid-template-columns: 1fr auto;
    align-items: center;
}

.gas-public-members__cantons-head div {
    display: flex;
    gap: 8px;
}

.gas-public-members__cantons-head button {
    border: 1px solid var(--gas-color-border);
    border-radius: 999px;
    background: var(--gas-color-surface);
    padding: 5.6px 11.2px;
    cursor: pointer;
}

.gas-public-members__canton-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 11.2px;
}

.gas-public-members__canton {
    display: inline-flex;
    grid-template-columns: auto auto;
    align-items: center;
    gap: 5.6px;
    border: 1px solid var(--gas-color-border);
    border-radius: 999px;
    padding: 6.4px 11.2px;
    background: var(--gas-color-surface-muted);
}

.gas-public-members__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

.gas-public-members__summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    margin-bottom: 16px;
}

.gas-public-members__summary p {
    margin: 4px 0 0;
    color: var(--gas-color-muted);
}

.gas-public-members__toolbar {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
    margin-bottom: 12px;
}

.gas-public-members__toolbar label {
    display: flex;
    align-items: center;
    gap: 8px;
}

.gas-public-members__table-wrap {
    overflow-x: auto;
    border: 1px solid var(--gas-color-border);
    border-radius: var(--gas-radius-xl);
    background: var(--gas-color-surface);
}

.gas-public-members__table {
    width: 100%;
    border-collapse: collapse;
    min-width: 980px;
}

.gas-public-members__table th,
.gas-public-members__table td {
    padding: 12.8px 12px;
    border-bottom: 1px solid var(--gas-color-border);
    text-align: left;
    vertical-align: middle;
}

.gas-public-members__table th {
    color: var(--gas-color-muted);
    font-size: 13.12px;
    text-transform: uppercase;
    letter-spacing: .04em;
    background: var(--gas-color-surface-muted);
}

.gas-public-members__photo {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--gas-color-surface);
    box-shadow: var(--gas-shadow-sm);
}

.gas-public-members__name {
    font-weight: 800;
    color: var(--gas-color-primary);
    text-decoration: none;
}

.gas-public-members__name:hover {
    text-decoration: underline;
}

.gas-public-members__muted {
    color: var(--gas-color-muted);
}

.gas-public-members__pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 16px;
    margin-top: 16px;
}

@media (max-width: 760px) {
    .gas-public-members__hero,
    .gas-public-members__summary {
        display: grid;
    }

    .gas-public-members__filter-grid {
        grid-template-columns: 1fr;
    }

    .gas-public-members__cantons-head {
        grid-template-columns: 1fr;
    }
}
